import './bluebirdConfig';

export const apiSettings = {
  url: process.env.STATSRADIO_APP_APIHOST,
  headers: {
    'X-Api-Key': process.env.STATSRADIO_APP_PUBLIC_APIKEY,
  },
};

export const websocketSettings = {
  url: process.env.STATSRADIO_APP_WEBSOCKETHOST,
};

export const version = {
  hashCommit: process.env.STATSRADIO_APP_COMMIT_HASH,
  tagName: process.env.STATSRADIO_APP_TAG_NAME,
  dateTime: process.env.STATSRADIO_APP_DEPLOY_DATETIME,
};

const cdnHost = process.env.STATSRADIO_APP_CDNHOST;
export const cdn = {
  maps: `${cdnHost}/maps`,
};

export const sentry = {
  dsn: process.env.STATSRADIO_APP_SENTRY_DSN,
  env: process.env.STATSRADIO_APP_SENTRY_ENV,
};

export const head = {
  titleTemplate: '%s - StatsRadio™',
  defaultTitle: "StatsRadio™ - Intelligence d'affaires pour radiodiffuseurs",
  meta: [
    {
      name: 'description',
      content:
        'StatsRadio™ modernise un des médias les plus efficaces en fournissant des statistiques d’écoute en temps réel. Nous avons créé un outil d’analyse d’audience simple et efficace accessible via une plateforme web.', // eslint-disable-line
    },
  ],
};

export const statsRadioFreshdeskWidgetId = process.env.STATSRADIO_APP_FRESHDESK_WIDGET_ID;



// WEBPACK FOOTER //
// ./src/common/config/config.js